"use strict";

var _toConsumableArray = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ArrayCursor = /*#__PURE__*/function () {
  function ArrayCursor(connection, body, host) {
    _classCallCheck(this, ArrayCursor);

    this.extra = body.extra;
    this._connection = connection;
    this._result = body.result;
    this._hasMore = Boolean(body.hasMore);
    this._id = body.id;
    this._host = host;
    this.count = body.count;
  }

  _createClass(ArrayCursor, [{
    key: "_drain",
    value: function _drain() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._more();

              case 2:
                if (this._hasMore) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", this);

              case 4:
                return _context.abrupt("return", this._drain());

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "_more",
    value: function _more() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$_result, res;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._hasMore) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return this._connection.request({
                  method: "PUT",
                  path: "/cursor/".concat(this._id),
                  host: this._host
                });

              case 6:
                res = _context2.sent;

                (_this$_result = this._result).push.apply(_this$_result, _toConsumableArray(res.body.result));

                this._hasMore = res.body.hasMore;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "delete",
    value: function _delete() {
      return this._connection.request({
        method: "DELETE",
        path: "/cursor/".concat(this._id)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "all",
    value: function all() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._drain();

              case 2:
                result = this._result;
                this._result = [];
                return _context3.abrupt("return", result);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "next",
    value: function next() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!this._result.length && this._hasMore)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return this._more();

              case 3:
                _context4.next = 0;
                break;

              case 5:
                if (this._result.length) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", undefined);

              case 7:
                return _context4.abrupt("return", this._result.shift());

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      return Boolean(this._hasMore || this._result.length);
    }
  }, {
    key: "each",
    value: function each(fn) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var index, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                index = 0;

              case 1:
                if (!(this._result.length || this._hasMore)) {
                  _context5.next = 15;
                  break;
                }

                result = void 0;

              case 3:
                if (!this._result.length) {
                  _context5.next = 10;
                  break;
                }

                result = fn(this._result.shift(), index, this);
                index++;

                if (!(result === false)) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt("return", result);

              case 8:
                _context5.next = 3;
                break;

              case 10:
                if (!this._hasMore) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 13;
                return this._more();

              case 13:
                _context5.next = 1;
                break;

              case 15:
                return _context5.abrupt("return", true);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "every",
    value: function every(fn) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var index, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                index = 0;

              case 1:
                if (!(this._result.length || this._hasMore)) {
                  _context6.next = 15;
                  break;
                }

                result = void 0;

              case 3:
                if (!this._result.length) {
                  _context6.next = 10;
                  break;
                }

                result = fn(this._result.shift(), index, this);
                index++;

                if (result) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", false);

              case 8:
                _context6.next = 3;
                break;

              case 10:
                if (!this._hasMore) {
                  _context6.next = 13;
                  break;
                }

                _context6.next = 13;
                return this._more();

              case 13:
                _context6.next = 1;
                break;

              case 15:
                return _context6.abrupt("return", true);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "some",
    value: function some(fn) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var index, result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                index = 0;

              case 1:
                if (!(this._result.length || this._hasMore)) {
                  _context7.next = 15;
                  break;
                }

                result = void 0;

              case 3:
                if (!this._result.length) {
                  _context7.next = 10;
                  break;
                }

                result = fn(this._result.shift(), index, this);
                index++;

                if (!result) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return", true);

              case 8:
                _context7.next = 3;
                break;

              case 10:
                if (!this._hasMore) {
                  _context7.next = 13;
                  break;
                }

                _context7.next = 13;
                return this._more();

              case 13:
                _context7.next = 1;
                break;

              case 15:
                return _context7.abrupt("return", false);

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "map",
    value: function map(fn) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var index, result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                index = 0;
                result = [];

              case 2:
                if (!(this._result.length || this._hasMore)) {
                  _context8.next = 9;
                  break;
                }

                while (this._result.length) {
                  result.push(fn(this._result.shift(), index, this));
                  index++;
                }

                if (!this._hasMore) {
                  _context8.next = 7;
                  break;
                }

                _context8.next = 7;
                return this._more();

              case 7:
                _context8.next = 2;
                break;

              case 9:
                return _context8.abrupt("return", result);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "reduce",
    value: function reduce(fn, accu) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var index;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                index = 0;

                if (!(accu === undefined)) {
                  _context9.next = 7;
                  break;
                }

                if (!(!this._result.length && !this._hasMore)) {
                  _context9.next = 5;
                  break;
                }

                _context9.next = 5;
                return this._more();

              case 5:
                accu = this._result.shift();
                index += 1;

              case 7:
                if (!(this._result.length || this._hasMore)) {
                  _context9.next = 14;
                  break;
                }

                while (this._result.length) {
                  accu = fn(accu, this._result.shift(), index, this);
                  index++;
                }

                if (!this._hasMore) {
                  _context9.next = 12;
                  break;
                }

                _context9.next = 12;
                return this._more();

              case 12:
                _context9.next = 7;
                break;

              case 14:
                return _context9.abrupt("return", accu);

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }]);

  return ArrayCursor;
}();

exports.ArrayCursor = ArrayCursor;